import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import Select from "react-select";
import { getAllUserData, getEventDetailsById, getEventUpdate } from "../../api";
import { useSelector } from "react-redux";
import { EventDetailsSchema } from "../../schema";
import ImageCropUpload from "../common/ImageCropUpload";

const EditEventDetails = ({ id }) => {
  const { token } = useSelector((state) => state.profileReducer);
  const [event, setEvent] = useState();
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [selectedImage, setSelectedImage] = useState(null);
  const [serviceData, setServiceData] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);

  useEffect(() => {
    async function getAllAPI() {
      await getEventdata();
      await getMembers();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setInitialTime = (utcTime) => {
    // Convert UTC time to local time zone
    const [timePart] = utcTime.split(" ");
    const [hours, minutes] = timePart.split(":");

    // Convert to 24-hour format
    let hourValue = Number(hours);
    // if (meridiem.toLowerCase() === 'PM' && hourValue !== 12) {
    //   hourValue += 12;
    // } else if (meridiem.toLowerCase() === 'AM' && hourValue === 12) {
    //   hourValue = 0;
    // }

    // Format the time as "HH:mm"
    const formattedTime = `${String(hourValue).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
    return formattedTime;
    // Set the formatted time in the formik state
  };

  const initialValues = {
    image: event ? event?.image : "",
    name: event ? event?.name : "",
    date: event ? event?.date : "",
    time: event ? setInitialTime(event?.time) : "",
    // moment(event?.time).format("LTS") : "",
    location: event ? event?.location : "",
    members: [],
    chosenMembers: event
      ? event?.userResult?.map((ele) => {
          return {
            id: ele.id,
            value: ele.id,
            label: ele?.first_name + " " + ele?.last_name,
          };
        })
      : [],
    status: event ? event?.status : "",
    description: event ? event?.description : "",
  };

  const editEventHandler = async (values) => {
    const formData = new FormData();
    formData.append("image", values.image);
    formData.append("name", values.name);
    formData.append("date", values.date);
    formData.append("time", values.time);
    formData.append("location", values.location);
    formData.append(
      "userId",
      values.chosenMembers?.map((ele) => ele.id).join(",")
    );
    formData.append("status", values.status);
    formData.append("description", values.description);

    getEventUpdate(id, formData, token)
      .then((res) => {
        setIsLoading(true);
        // toast.current.show({
        //   severity: "success",
        //   summary: `${res?.data?.message}`,
        // });
        setTimeout(() => {
          setIsLoading(false);
          navigate(-1);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const getEventdata = () => {
    getEventDetailsById(id, token)
      .then((res) => {
        // toast.current.show({severity: 'success', summary: `${res?.data?.message}`});
        setEvent(res?.data?.data[0]);
        setPreviewImg(res?.data?.data[0].image);
        setServiceData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };

  const getMembers = async () => {
    getAllUserData(token)
      .then((res) => {
        let arr = [];
        res?.data?.result?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.id,
            label: ele?.first_name + " " + ele?.last_name,
          })
        );
        setFieldValue("members", arr);
      })
      .catch((err) => {});
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: EventDetailsSchema(),
    onSubmit: (values) => editEventHandler(values),
  });

  // const handleOnChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFieldValue("image", file);
  //     setUploadedFileName(file.name);
  //   }
  // };

  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setSelectedImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  // if (e.target.files.length) {
  //   setFieldValue(e.target.files.name, e?.target?.files);
  // } else {
  //   setFieldValue(e.target.name, values[e.target.name]);
  // }

  // const onsaveimage = async (id) => {

  //   await getEventUpdate(
  //     id,
  //     formData,
  //     token
  //     // {
  //     //   userId: serviceData?.userId
  //     //     .split(",")
  //     //     .filter((ele) => ele !== Userid)
  //     //     .join(),
  //     //     image: image1
  //     // },
  //   )
  //     .then((res) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "success",
  //         summary: `${res?.data?.message}`,
  //       });
  //       setTimeout(() => {
  //         // navigate("event-management/EventDetails");
  //       }, 1000);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "error",
  //         summary: `${err?.response?.data?.message}`,
  //       });
  //     });
  // };

  const navigate = useNavigate();
  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="">
        <div className="event-details-all-starting-part mt-4">
          <div className="userprofile-pics">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="cursor-pointer"
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Back to Event Details</h6>
              </div>
            </div>
          </div>

          {event && (
            <div className="main-profile-all-cls-start mt-4">
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-4 position-relative initial-set-only-z eventdetails-img-cls">
                    <label className="my-2">Upload event image</label>
                    {/* Image preview */}
                    {/* {selectedImage && (
                      <img
                        src={selectedImage}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    )} */}
                    {previewImg && serviceData && (
                      <div className="text-centersall">
                        <img
                          src={
                            previewImg
                              ? previewImg
                              : require("../../assets/defaultImg.png")
                          }
                          alt="Preview1"
                        />
                      </div>
                    )}
                    <div className="change-photo-btn mt-4">
                      <span className="required">
                        {" "}
                        Crop will be saved as 300w X 280h
                      </span>
                      <ImageCropUpload
                        name="image"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        onBlur={handleBlur}
                        onCroppedFile={(file) =>
                          setPreviewImg(URL.createObjectURL(file))
                        }
                        error={errors.image}
                        touched={touched.image}
                      />
                    </div>
                    {/* {uploadedFileName} */}

                    {/* <label for="exampleFormControlInput1">
                      Click Here to edit Image :{"  "}
                    </label> */}
                    <span className="upload-all-btns-cls-add"></span>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Event Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput2"
                      placeholder="Please Enter Title Here"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.name && touched.name ? (
                      <p className="form-error">{errors.name}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="exampleFormControlInput2"
                      placeholder="Please Enter Title Here"
                      name="date"
                      value={values.date}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.date && touched.date ? (
                      <p className="form-error">{errors.date}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-4">
                    <label className="my-2">Time</label>
                    <input
                      type="time"
                      // onChange={onTimeChange()}
                      // id="timeInput"
                      // step="2"
                      className="form-control"
                      id="exampleFormControlInput3"
                      placeholder="Write here"
                      name="time"
                      value={values.time}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.time && touched.time ? (
                      <p className="form-error">{errors.time}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Location</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput2"
                      placeholder="Please Enter Location Here"
                      name="location"
                      value={values.location}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Members</label>
                    <Select
                      name="chosenMembers"
                      className="select-multiple-all-drop"
                      isMulti
                      options={values.members}
                      placeholder="Select Members"
                      onBlur={handleBlur}
                      value={values.chosenMembers}
                      onChange={(selectedMembers) => {
                        setFieldValue("chosenMembers", selectedMembers);
                      }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">
                      Status <span className="required">*</span>
                    </label>
                    <select
                      name="status"
                      value={values.status}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="" disabled hidden>
                        Select Status
                      </option>
                      <option value="Requested" label="Requested">
                        Requested
                      </option>
                      <option value="On Going" label="On Going">
                        On Going
                      </option>
                      <option value="Completed" label="Completed">
                        Completed
                      </option>
                      <option value="Cancelled" label="Cancelled">
                        Cancelled
                      </option>
                    </select>
                  </div>
                  {/* <div className="row mt-4"> */}
                  <div className="col-lg-8">
                    <label className="my-2"> Description</label>
                    <textarea
                      className="form-control"
                      placeholder="Please Enter Description Here"
                      name="description"
                      id="floatingTextarea"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {errors.content && touched.content ? (
                      <p className="form-error">{errors.content}</p>
                    ) : null}
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="right-sidebtn-add text-end mt-5">
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              onClick={() => {
                navigate(-1);
              }}
              className="btn btn-primary outline-btn-cls me-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary filled-btn-cls"
              // onClick={() => onsaveimage(id)}
            >
              Edit
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default EditEventDetails;
